import {
  cn,
  layout,
  spacing,
  typography
} from "@/utilities/tailwind-utils";

interface EmptyStateProps {
  message?: string;
  className?: string;
}

export function EmptyState({ message = "No items found", className }: EmptyStateProps) {
  return (
    <div className={cn(layout.flexCenter, spacing.py8, className)}>
      <p className={typography.textMuted}>{message}</p>
    </div>
  );
}
